import './styles/main.scss'
import { createApp } from 'vue'
import { KeycloakKeyIds } from '@/constants'
import { registerPlugins } from '@/plugins'
import Keycloak from 'keycloak-js'
import { useKeycloak } from '@deepcloud/keycloak'

function getKeycloakInitLocale(): string | undefined {
  const params = new URLSearchParams(window.location.search)
  const lang = params.get('lang')
  return lang || undefined
}

const { onReady: onKeycloakReady } = useKeycloak({
  keycloak: new Keycloak({
    url: `${import.meta.env.VITE_IDP_URL}/${import.meta.env.VITE_IDP_URL_AUTH}`,
    realm: import.meta.env.VITE_IDP_REALM,
    clientId: import.meta.env.VITE_IDP_CLIENT_ID,
  }),

  initParams: {
    enableLogging:
      ((import.meta.env.VITE_ENVIRONMENT === 'local') as boolean) ||
      ((import.meta.env.VITE_ENVIRONMENT === 'dev') as boolean),
    timeSkew: 0,
    locale: getKeycloakInitLocale(),
    onLoad: 'login-required',
    checkLoginIframe: false,
    silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
    scope: import.meta.env.VITE_IDP_SCOPES.replaceAll(',', ' '),
    token: sessionStorage.getItem(KeycloakKeyIds.KC_TOKEN) || undefined,
    refreshToken:
      sessionStorage.getItem(KeycloakKeyIds.KC_REFRESH_TOKEN) || undefined,
    pkceMethod: 'S256',
  },
})

onKeycloakReady(async () => {
  const { default: App } = await import('./App.vue')
  const app = createApp(App)

  registerPlugins(app)

  app.mount('#app')
})
